import ErrorIllustration from '@propertypal/shared/src/resources/icons/misc/error.svg';
import Link from 'next/link';
import React from 'react';
import { Container } from './PageNotFound.style.pn';

const PageNotFound = () => {
  return (
    <Container>
      <ErrorIllustration />

      <h1>404</h1>

      <h2>Page not found</h2>

      <p>Oops… We can’t seem to find the page you are looking for!</p>

      <p>Don’t worry, click below to go back to Propertynews and let us help you find your happy place!</p>

      <p>
        <Link href="/">Back to the homepage</Link>
      </p>
    </Container>
  );
};

export default PageNotFound;
